<template>
  <div id="destaque-pdf" :style="{ opacity: clientOpacity }">
    <b-container>
      <b-row>
        <b-col cols="12" class="py-2"></b-col>
      </b-row>
    </b-container>
    <b-container fluid id="barraSecundaria-pdf"></b-container>
  </div>
</template>

<script>
  export default {
    name: 'Destaque',
    data() {
      return {
        client: null
      }
    },
    computed: {
      clientOpacity() {
        return this.client === 'DOE-AL' ? '1' : '0.95'
      }
    }
  }
</script>

<style lang="scss">
  @import '@/assets/scss/estilos.scss';
  #destaque-pdf {
    background-color: $corPrimaria;
    width: calc(100% + 30px);
    margin-right: -15px;
    margin-left: -15px;
    opacity: 0.95;
    box-shadow: $sombraProjetadaCima;
    -webkit-box-shadow: $sombraProjetadaCima;
    #barraSecundaria-pdf {
      height: 6px;
      background-color: $corSecundaria;
      box-shadow: $sombraProjetadaCima;
      -webkit-box-shadow: $sombraProjetadaCima;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/pdf/destaque.vue